import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import AppContext from "app/appContext";
import GullLayout from "app/GullLayout/GullLayout";
import { flatMap } from "lodash";
import { SetPermission } from "app/Components/SetPermission/Permissions";
import { logoutUser } from "app/redux/actions/UserActions";
function removeExtraKeys(temp) {
  if (!temp) return "";

  const re =
    /:type|:landTyeId|:individualId|:id|:ExId|:wellInfoId|:leaseId|:projectId|:civilWorkStatusId|:opdId|:landOwnerId|:casingId|:wellId|:nptId|:LAQId|:CId|:HfId|:drId|:ActivityId|:sId|:GSSId|:casingRowId|:casingDataDowId|:rigId|:workoverDetailsId|:dprId|:dpId|:siteId/gi;
  const newStr = temp.replace(re, (match) => "");

  return newStr;
}
class AuthGuard extends Component {
  constructor(props, context) {
    super(props);
    let { routes } = context;

    this.state = {
      authenticated: true,
      nav: 0,
      routes,
    };
  }

  componentDidMount() {
    this.setState({
      routes: flatMap(this.state.routes, (item) => {
        if (item.routes) {
          return [...item.routes];
        }
        return [item];
      }),
    });

    if (!this.state.authenticated) {
      this.redirectRoute(this.props);
    }
  }

  componentDidUpdate() {
    if (!this.state.authenticated) {
      this.redirectRoute(this.props);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextState.authenticated !== this.state.authenticated ||
      nextState.nav !== this.state.nav
    );
  }

  static getDerivedStateFromProps(props, state) {
    const { location, user, route, history } = props;
    const { pathname } = location;
    let currentUrl = pathname;
    let authenticated = false;

    let matched = null;
    const IsPathNumeric = currentUrl.match(/\d+/g);
    if (IsPathNumeric && IsPathNumeric.length) {
      currentUrl = currentUrl.replace(/\d+/g, "");
      matched = state.routes.find((r) => removeExtraKeys(r.path) === currentUrl);
    } else {
      matched = state.routes.find((r) => r.path === currentUrl);
    }

    //codefire
    let nav = 0;
    if (matched && matched.nav) {
      nav = matched.nav;
    }

    authenticated =
      matched && matched.auth && matched.auth.length
        ? matched.auth.includes(user.role)
        : true;

    // console.log("/*/*/**/**//user", currentUrl);
    const routePathData = route.routes.find((d) => removeExtraKeys(d.path) == currentUrl);
    if (routePathData?.permission) {
      const permissionStatus = SetPermission({
        permission: routePathData.permission,
        data: "true",
      });
      if (!permissionStatus) {
        props.logoutUser();
        authenticated = false;
      }
    }
    return {
      authenticated,
      nav,
    };
  }

  redirectRoute(props) {
    const { location, history } = props;
    const { pathname } = location;

    history.push({
      pathname: "/session/signin",
      state: { redirectUrl: pathname },
    });
  }

  render() {
    let { route } = this.props;
    const { authenticated } = this.state;

    return authenticated ? (
      <Fragment>
        <GullLayout activeMenu={this.state.nav} route={route}></GullLayout>
      </Fragment>
    ) : null;
  }
}

AuthGuard.contextType = AppContext;

const mapStateToProps = (state) => ({
  user: state.user,
});

export default withRouter(
  connect(mapStateToProps, {
    logoutUser,
  })(AuthGuard)
);
